var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCopyOutlineIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 13.125V6a3 3 0 0 0-3-3H9.875M14 21H7.25A2.25 2.25 0 0 1 5 18.75V9a2.25 2.25 0 0 1 2.25-2.25H14A2.25 2.25 0 0 1 16.25 9v9.75A2.25 2.25 0 0 1 14 21Z",
    stroke: "#002FF1",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyOutlineIcon);
export default __webpack_public_path__ + "static/media/copy-outline-icon.422b315249d229f58cffe08b7f350f57.svg";
export { ForwardRef as ReactComponent };